/** Zeitpunkt für die Anzeige -- lokale Uhrzeit statt ISO-Rohwert. */
export function formatDate(value: string | null): string {
  return value ? new Date(value).toLocaleString('de-DE') : '—';
}

/**
 * Ohne Klammern -- die Tabelle zeigt die Koordinaten als eigene Spalte.
 * Nimmt bewusst nur `{ coordinates }` entgegen (nicht `ReportSide` selbst),
 * damit sich das auch für andere Stellen mit Koordinaten nutzen lässt (z. B.
 * `DefenderVillageUnits`, die Truppen in anderen Dörfern des Verteidigers).
 */
export function formatCoords(entry: { coordinates: { x: number; y: number } | null }): string {
  return entry.coordinates ? `${entry.coordinates.x}|${entry.coordinates.y}` : '—';
}
